<template>
  <span class="ml-1 tooltip-trigger">
    <TooltipIcon :id="`${id}-tooltip`" />
    <b-tooltip :target="`${id}-tooltip`" triggers="hover" placement="right">
      {{ info }}
    </b-tooltip>
  </span>
</template>

<script>
import TooltipIcon from '../../assets/icons/tooltip.svg';

export default {
  name: 'Tooltip',
  components: {
    TooltipIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip-trigger {
  position: relative;
  top: -2px;
  cursor: pointer;
}
</style>
